import styled from "styled-components";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";

import { ko } from "date-fns/locale";

import "react-datepicker/dist/react-datepicker.css";

import { typography } from "globalConstants";
// import { Default } from "Types";
import { Molecules } from "Types/Components";

import AtomLabel from "Components/Atoms/Label";
// import AtomDatePicker from "Components/Atoms/DatePicker2";

export type PropsType = Molecules.FormDateRange;

registerLocale("ko", ko);

const Wrap = styled.label<any>`
   display: flex;
   flex-direction: column;
   row-gap: 10px;
   margin-top: 25px;
   ${({ css }) => css}
`;

const ControlWrap = styled.div``;

const StyledDatePicker = styled(DatePicker)`
   ${typography.other.t5}
   outline: none;
   border: 1px solid ${typography.other.color.gray[2]};
   color: black;
   border-radius: 4px;
   height: 40px;
   box-sizing: border-box;
   padding: 0px 10px;
   width: 100%;
   flex-grow: 1;
   &::placeholder {
      color: ${typography.other.color.gray[2]};
   }
`;

const ExportDatePicker = (props: any) => {
   return <StyledDatePicker dateFormat="yyyy-MM-dd" locale="ko" {...props}></StyledDatePicker>;
};

export default function MoleculeFormDateRange(props: any) {
   return (
      <Wrap {...props}>
         <AtomLabel>{props.label}</AtomLabel>
         <ControlWrap>
            {/* <AtomDatePicker value={props.value} onChange={props.onChange}></AtomDatePicker> */}
            <ExportDatePicker selected={props.value} onChange={props.onChange}></ExportDatePicker>
         </ControlWrap>
      </Wrap>
   );
}

MoleculeFormDateRange.Wrap = Wrap;
MoleculeFormDateRange.Label = AtomLabel;
MoleculeFormDateRange.DatePicker = ExportDatePicker;
